// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-container {
  padding: 10px;
  padding-bottom: 20px;
  overflow: hidden;
}
.wizard-container .tab-title {
  font-size: 20px;
  color: #3e5777;
  border-bottom: 1px solid #3e5777;
  margin: 16px 4px 4px;
}
.wizard-container .department-description-container {
  padding: 0 4px;
}
.wizard-container .department-description-container p {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 0.9em;
  color: #676767;
}
.wizard-container .department-description-container p.parameter {
  margin-top: 7px;
  font-weight: bold;
  font-size: 0.9em;
  color: #333;
}
.wizard-container .no-department-container {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  padding: 0 4px;
}
.wizard-container .no-department-container p {
  margin-top: 0;
  margin-bottom: 0;
  color: red;
}
.wizard-container .no-department-container p.parameter {
  margin-top: 7px;
  font-weight: bold;
  font-size: 0.9em;
}
.wizard-container .no-department-container button {
  margin-top: 14px;
  align-self: stretch;
}
@media screen and (min-width: 600px) {
  .wizard-container .no-department-container button {
    align-self: initial;
    width: 320px;
  }
}

:host ::ng-deep .mat-mdc-raised-button {
  border-radius: 0;
}
:host ::ng-deep .name {
  margin: 16px 4px 16px 4px !important;
}
:host ::ng-deep .mdc-notched-outline .mdc-floating-label--float-above {
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/request-editor/request-editor.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oBAAA;EACA,gBAAA;AACJ;AAAI;EACI,eAAA;EACA,cAAA;EACA,gCAAA;EACA,oBAAA;AAER;AAAI;EACI,cAAA;AAER;AADQ;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAGZ;AAFY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAIhB;AAAI;EACI,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAER;AADQ;EACI,aAAA;EACA,gBAAA;EACA,UAAA;AAGZ;AAFY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAIhB;AADQ;EACI,gBAAA;EACA,mBAAA;AAGZ;AAFY;EAHJ;IAIQ,mBAAA;IACA,YAAA;EAKd;AACF;;AACI;EACI,gBAAA;AAER;AAAI;EACI,oCAAA;AAER;AAAI;EACI,uBAAA;AAER","sourcesContent":[".wizard-container {\n    padding: 10px;\n    padding-bottom: 20px;\n    overflow: hidden;\n    .tab-title {\n        font-size: 20px;\n        color: #3e5777;\n        border-bottom: 1px solid #3e5777;\n        margin: 16px 4px 4px;\n    }\n    .department-description-container {\n        padding: 0 4px;\n        p {\n            margin-top: 0;\n            margin-bottom: 0;\n            font-size: 0.9em;\n            color: #676767;\n            &.parameter {\n                margin-top: 7px;\n                font-weight: bold;\n                font-size: 0.9em;\n                color: #333;\n            }\n        }\n    }\n    .no-department-container {\n        display: flex;\n        flex-flow: column;\n        align-items: flex-start;\n        padding: 0 4px;\n        p {\n            margin-top: 0;\n            margin-bottom: 0;\n            color: red;\n            &.parameter {\n                margin-top: 7px;\n                font-weight: bold;\n                font-size: 0.9em;\n            }\n        }\n        button {\n            margin-top: 14px;\n            align-self: stretch;\n            @media screen and (min-width: 600px) {\n                align-self: initial;\n                width: 320px;\n            }\n        }\n    }\n}\n\n:host ::ng-deep {\n    & .mat-mdc-raised-button {\n        border-radius: 0;\n    }\n    & .name {\n        margin: 16px 4px 16px 4px !important;\n    }\n    & .mdc-notched-outline .mdc-floating-label--float-above {\n        text-overflow: ellipsis;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
